import React from 'react';
import Fab from '@mui/material/Fab';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { PALETTE } from '~/assets/styles/base';

type Props = {
  href: string;
  placement?: TooltipProps['placement'];
};

const HelpButton: React.FC<Props> = ({ href, placement = 'right' }): JSX.Element => (
  <Tooltip title="Help" placement={placement}>
    <Fab
      data-testid="uiParts-HelpButton-Fab"
      color="info"
      href={href}
      rel="noopener noreferrer"
      aria-label="question"
      target="_blank"
    >
      <QuestionMarkIcon
        data-testid="uiParts-HelpButton-QuestionMarkIcon"
        sx={{ color: PALETTE.primary.main }}
        fontSize="large"
      />
    </Fab>
  </Tooltip>
);

export default HelpButton;
